<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-document-copy"></i> 二维码管理</span>
      </div>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="二维码类型">
              <el-input
                v-model="queryParams.type"
                placeholder="请输入类型"
                clearable
                style="width: 250px"
              />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="编号">
              <el-input
                v-model="queryParams.serialNo"
                placeholder="请输入编号"
                clearable
                style="width: 250px"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">
            新增
          </el-button>
          <el-button
            type="success"
            icon="el-icon-download"
            @click="downloadSelected"
            :disabled="selectedRows.length === 0"
          >
            下载二维码
          </el-button>
        </el-row>
      </el-form>

      <!-- 二维码管理表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
        ref="table"
        @selection-change="handleSelectionChange"
      >
        <!-- 多选列 -->
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column label="类型" prop="type"></el-table-column>
        <el-table-column label="编号" prop="serialNo">
          <template slot-scope="scope">
            <span>{{ scope.row.serialNo }}</span>
            <i
              class="el-icon-document-copy copy-icon"
              style="cursor: pointer; margin-left: 8px; color: #409eff"
              @click="copyText(scope.row.serialNo)"
            ></i>
          </template>
        </el-table-column>

        <el-table-column label="二维码" prop="contentBase64">
          <template v-slot="scope">
            <div class="imgBox">
              <img
                :src="getBase64Image(scope.row.contentBase64)"
                alt="二维码"
                style="width: 50px; height: 50px"
              />
              <el-button
                type="text"
                @click="previewQRCode(scope.row.contentBase64)"
                style="margin-left: 8px"
              >
                预览
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="状态" prop="state">
          <template v-slot="scope">
            <el-tag :type="scope.row.state === 1 ? 'success' : 'info'">
              {{ scope.row.state === 1 ? "已使用" : "未使用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button
              size="mini"
              @click="deleteQRCode(scope.row)"
              type="danger"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :title="isEdit ? '编辑二维码' : '新增二维码'"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="currentQRCode"
          ref="form"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="类型" prop="type">
            <el-input
              v-model="currentQRCode.type"
              placeholder="请输入类型"
            ></el-input>
          </el-form-item>
          <el-form-item label="数量" prop="amount">
            <el-input
              v-model="currentQRCode.amount"
              type="number"
              placeholder="请输入数量"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveQRCode">
            {{ isEdit ? "更新" : "确 定" }}
          </el-button>
        </span>
      </el-dialog>

      <!-- 二维码预览弹窗 -->
      <el-dialog
        title="二维码预览"
        :visible.sync="previewDialogVisible"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div style="text-align: center">
          <img
            :src="currentPreviewImage"
            alt="二维码预览"
            style="max-width: 100%; height: auto"
          />
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  qrcodePage,
  qrcodeAdd,
  qrcodeDelete,
  qrcodeDownload,
} from "@/api/config";
import PaginationBar from "@/components/PaginationBar";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      previewDialogVisible: false,
      currentPreviewImage: null,
      queryParams: {
        type: "", // 查询条件
        serialNo: "",
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      allData: [],
      rules: {
        type: [{ required: true, message: "类型是必填项", trigger: "blur" }],
        amount: [{ required: true, message: "数量是必填项", trigger: "blur" }],
      },
      tableData: [],
      dialogVisible: false,
      currentQRCode: {
        type: "",
        amount: "",
      },
      selectedRows: [], // 选中的二维码数据
      isEdit: false, // 新增还是编辑标识
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    copyText(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$message.success("复制成功");
        })
        .catch(() => {
          this.$message.error("复制失败，请手动复制");
        });
    },
    previewQRCode(base64Data) {
      this.currentPreviewImage = this.getBase64Image(base64Data);
      this.previewDialogVisible = true;
    },
    getBase64Image(base64Data) {
      if (!base64Data) return "";
      // 判断是否已有 data:image 前缀
      if (base64Data.startsWith("data:image")) {
        return base64Data;
      }
      return `data:image/png;base64,${base64Data}`;
    },
    handleQuery(page) {
      // const { type } = this.queryParams;
      this.currentPage = page || 1;
      qrcodePage({
        ...this.queryParams,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams.type = "";
      this.queryParams.serialNo = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.isEdit = false; // 设置为新增
      this.currentQRCode = { type: "", amount: "" }; // 清空输入框
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true; // 设置为编辑
      this.currentQRCode = { ...row };
      this.dialogVisible = true;
    },
    saveQRCode() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = { ...this.currentQRCode };
          qrcodeAdd(params).then(() => {
            this.dialogVisible = false;
            this.handleQuery();
            this.$message.success("操作成功");
          });
        } else {
          return false;
        }
      });
    },
    deleteQRCode(row) {
      this.$confirm("确定删除此二维码?", "删除提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          qrcodeDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          });
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    downloadSelected() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择二维码");
        return;
      }

      const ids = [];
      this.selectedRows.forEach((row) => {
        console.log(row);
        ids.push(row.id);
      });

      console.log(ids);

      qrcodeDownload({ ids })
        .then((res) => {
          // 方案1: 检查响应类型并正确处理
          const blob = new Blob([res.data], { type: "application/zip" });
          console.log(blob.size); // 看文件大小
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "二维码压缩包.zip";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(downloadUrl);
        })
        .catch((error) => {
          this.$message.error("下载失败: " + error.message);
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
.imgBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
